import store from '~/store/index';
export default defineNuxtPlugin(({ vueApp }) => {
    vueApp.use(store);
});
//# sourceMappingURL=store.js.map